import React from 'react';
import {Field, FieldArray, FastField} from 'formik';
import {FormattedMessage} from 'react-intl';
import isEqual from 'react-fast-compare';
import messages from '../../../../res/translations/messages';
import Editor from './Editor';
import PageEditor from './PageEditor';
import Script from './Script';
import ScriptOptions from './ScriptOptions';
import ScriptRows from './ScriptRows';
import {constants} from '@neosvoc/nv-platform-core-common';

const scriptExclusions = [
    // constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER,
    constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER_2,
];

const hidableWidgets = [
    constants.EDITOR_TEMPLATES.TEXT_1,
    constants.EDITOR_TEMPLATES.IMAGE_1,
    constants.EDITOR_TEMPLATES.DATE_1,
];

class PageTypeItem extends React.Component {
    constructor(props) {
        super(props);
        this.renderEditor = this.renderEditor.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        return !isEqual(this.props, nextProps);
    }

    renderEditor(props) {
        return <Editor currPage={this.props.index} {...props} />;
    }

    render() {
        const {index, item, pageCount, items, parameters, extraFields} = this.props;
        const hideEnableWidget = hidableWidgets.includes(item.items[0].type);
        const scriptExcluded = scriptExclusions.includes(item.items[0].type);
        return (
            <>
                {!scriptExcluded &&
                    ((index > 0 || (parameters && parameters.length > 0) || (extraFields && extraFields.length > 0)) &&
                    index < pageCount - 1) || item.preScripts.length > 0 ?
                    <>
                        <h3><FormattedMessage {...messages.surveys.form.title.preScript} /></h3>
                        <Script id={`editor.pages.${index}.preScripts`} currPage={index} postScript={false}
                            allowAdd={(index > 0 || (parameters && parameters.length > 0) || (extraFields && extraFields.length > 0)) && index < pageCount - 1}
                            items={items} />
                    </> :
                    null
                }

                {!scriptExcluded &&
                    (index > 0 || (parameters && parameters.length > 0) || (extraFields && extraFields.length > 0)) &&
                    (item.items[0].choices || (item.items[0].choices && item.items[0].choices.length > 0)) ?
                    <>
                        <h3><FormattedMessage {...messages.surveys.form.title.optionScript} /></h3>
                        <ScriptOptions id={`editor.pages.${index}.optionsScripts`} currPage={index} items={items} />
                    </> :
                    null
                }

                {!scriptExcluded &&
                    (index > 0 || (parameters && parameters.length > 0) || (extraFields && extraFields.length > 0)) &&
                    (item.items[0].rows || (item.items[0].rows && item.items[0].rows.length > 0)) ?
                    <>
                        <h3><FormattedMessage {...messages.surveys.form.title.rowScript} /></h3>
                        <ScriptRows id={`editor.pages.${index}.rowsScripts`} currPage={index} items={items} />
                    </> :
                    null
                }

                <h3><FormattedMessage {...messages.surveys.form.title.page} /></h3>
                <Field name={`editor.pages.${index}.id`} component={PageEditor} />
                <h3><FormattedMessage {...messages.surveys.form.title.question} /></h3>
                <FieldArray name={`editor.pages.${index}.items`} render={this.renderEditor} />

                {!scriptExcluded &&
                    (index < pageCount - 1) || item.postScripts.length > 0 ?
                    <>
                        <h3><FormattedMessage {...messages.surveys.form.title.postScript} /></h3>
                        <Script id={`editor.pages.${index}.postScripts`} currPage={index} postScript={true} allowAdd={index < pageCount - 1} items={items} />
                    </> :
                    null
                }
                <h3><FormattedMessage {...messages.surveys.form.title.settings} /></h3>
                <div className="row pr-2">
                    <div className="col-3">
                        <FastField name={`editor.pages.${index}.terminal`}>
                            {({field}) => (
                                <div className="custom-control custom-checkbox">
                                    <input type="checkbox" name={field.name} id={field.name} className="custom-control-input"
                                        checked={field.value} onChange={field.onChange} />
                                    <label className="custom-control-label" htmlFor={field.name}>
                                        <FormattedMessage {...messages.surveys.form.label.terminal} />
                                    </label>
                                </div>
                            )}
                        </FastField>
                    </div>
                    {!hideEnableWidget &&
                        <div className="col-4">
                            <FastField name={`editor.pages.${index}.enableWidget`}>
                                {({field}) => (
                                    <div className="custom-control custom-checkbox">
                                        <input type="checkbox" name={field.name} id={field.name} className="custom-control-input"
                                            checked={field.value} onChange={field.onChange} />
                                        <label className="custom-control-label" htmlFor={field.name}>
                                            <FormattedMessage {...messages.surveys.form.label.enableWidget} />
                                        </label>
                                    </div>
                                )}
                            </FastField>
                        </div>
                    }
                </div>
            </>
        );
    }
}

export default PageTypeItem;
